import { getColumnInterval } from './getColumnInterval';
import { getColumnRange } from 'owa-calendar-surface-dategrid/lib/logic/getColumnRange';
import { shrink, SurfaceItem } from 'owa-calendar-surface-dategrid';

/**
 * Unfolds an unbounded item into multiple column-bound items,
 * one for each column in which the original item appears.
 */
export function unfoldSurfaceItem(
    item: SurfaceItem,
    columnCount: number,
    columnLength: number
): SurfaceItem[] {
    const result: SurfaceItem[] = [];

    let { start, end } = getColumnRange(item, columnCount, columnLength);
    for (let columnIndex = start; columnIndex < end; columnIndex++) {
        const columnBoundKey = item.key + '_' + columnIndex;
        const columnBoundItem = { ...item, key: columnBoundKey };
        shrink(columnBoundItem, getColumnInterval(columnIndex, columnLength));
        result.push(columnBoundItem);
    }

    return result;
}
